<div class="agpr-unsaved-export-preferences">
    <h5 class="agpr-headerH3-dark">
        {{ 'AMT.unsavedMentionExportLimit' | localize }}
        <span
            role="img"
            class="fa-regular fa-circle-info agpr-unsaved-export-preferences-infoIcon"
            agprTooltip="AMT.unsavedMentionExportLimit.tooltip"
        ></span>
    </h5>
    <div class="agpr-unsaved-export-preferences-wrapper">
        <agpr-message
            *ngIf="showQuotaBanner$ | async"
            class="agpr-unsaved-export-preferences-message"
            [severity]="messageSeverityEnum.info"
        >
            <div [innerHTML]="'AMT.subscriptions.unsavedMentionExportLimit.banner' | localize"></div>
        </agpr-message>
        <agpr-number-input
            id="monitoringConfigs_unsavedMentionExportLimit"
            class="agpr-unsaved-export-preferences-numberInput"
            [(ngModel)]="unsavedMentionExportLimit"
            label="AMT.unsavedMentionExportLimit.dailyLimit"
            placeholder="AMT.unsavedMentionExportLimit.enterLimit"
            [integerOnly]="true"
            [forceMinValue]="false"
            (blur)="checkUnsavedMentionExportLimit()"
            [min]="-1"
            [max]="999999999"
        ></agpr-number-input>
    </div>
</div>
